export const SET_LANGUAGE_ROWS = 'aiTemplate/SET_LANGUAGE_ROWS';
export const SET_LOCALE_ORDER = 'aiTemplate/SET_LOCALE_ORDER';
export const ADD_LANGUAGE = 'aiTemplate/ADD_LANGUAGE';
export const DELETE_LANGUAGE = 'aiTemplate/DELETE_LANGUAGE';
export const UPDATE_LANGUAGE_CELL = 'aiTemplate/UPDATE_LANGUAGE_CELL';
export const OPEN_ADD_LANGUAGE_MODAL = 'aiTemplate/OPEN_ADD_LANGUAGE_MODAL';
export const CLOSE_ADD_LANGUAGE_MODAL = 'aiTemplate/CLOSE_ADD_LANGUAGE_MODAL';
